<template>
  <div class="form-quizz-question-item-component mb-3">
    <div class="quizz-question-header">
      <button
        class="btn btn-sm btn-header p-0 m-0"
        @click.prevent="editing = !editing"
      >
        <div>
          <i v-if="isAllSaved" class="ph ph-dots-six-vertical handle lead" />
        </div>
        <h5 class="text-semibold">
          {{ item.title }}
        </h5>
        <i
          class="ph"
          :class="{
            'ph-caret-up': editing,
            'ph-caret-down': !editing
          }"
        ></i>
      </button>
    </div>
    <template v-if="editing">
      <div class="quizz-question-content">
        <snow-input
          v-model="item.title"
          id="question"
          label="Questão"
          class="mb-1"
        />
        <div class="mb-1">
          <h5 class="text-semibold">Possíveis respostas</h5>
          <h6 class="text-dark-40">
            Ao finalizar selecione a resposta correta.
          </h6>
        </div>

        <div
          v-for="(alt, i) in valid_alternatives"
          :key="`alt-${i}`"
          class="d-flex align-items-center"
        >
          <b-form-radio
            v-model="right_answer"
            :id="`${alt.id}`"
            :value="`${alt.id}`"
            class="mr-2"
          />
          <snow-input
            v-model="alt.title"
            :id="`alternative-${alt.id}`"
            :label="`Opção de resposta ${i + 1}`"
            class="flex-fill mr-3"
          />
          <snow-button
            size="sm"
            variant="danger"
            text="Excluir"
            @click="removeAlternative(i)"
          />
        </div>
        <button class="button-add-question" @click="addAlternatives">
          <i class="ph ph-plus-circle mr-3" />
          <span>Clique para adicionar uma resposta...</span>
        </button>

        <div v-if="editing" class="d-flex justify-content-between mt-5">
          <snow-button
            size="sm"
            variant="danger"
            text="Excluir"
            @click="onRemoveQuestion"
          />
          <snow-button
            v-if="form.id"
            size="sm"
            text="Salvar"
            variant="gray"
            :disabled="!isValid"
            @click="submitSaveQuestion"
          />
        </div>

        <snow-dialog
          v-model="dialog_remove"
          title="Aviso"
          icon="ph ph-trash"
          secondaryButtonText="Cancelar"
          :text="`Deseja mesmo excluir a pergunta: ${item.title}?`"
          buttonText="Confirmar"
          @action="submitDeleteQuestion"
        />
      </div>
    </template>
  </div>
</template>
<script>
import { get_error_msg } from "@/functions/helpers";
import moment from "moment";

export default {
  props: {
    item: Object,
    form: Object,
    index: Number,
    isAllSaved: Boolean,
    isFinalQuiz: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (!this.item?.id) {
      this.editing = true;
    }
  },
  data() {
    const alternative = this.item.answer_options.find(a => a.is_right_answer);
    const right_answer = alternative ? alternative.id : null;
    return {
      dialog_remove: false,
      right_answer,
      loading: false,
      editing: false
    };
  },
  watch: {
    right_answer(id) {
      this.item.answer_options = [
        ...this.item.answer_options.map(o => ({
          ...o,
          is_right_answer: id && id == o.id
        }))
      ];
    }
  },
  computed: {
    valid_alternatives() {
      return this.item.answer_options.filter(alt => !alt.deleted);
    },
    question_without_right_answer() {
      if (this.item.answer_options.length) {
        return this.item.answer_options
          .filter(a => !a.deleted)
          .reduce((acc, curr) => acc || curr.is_right_answer, false);
      }

      return true;
    },
    question_without_title() {
      if (this.item.answer_options.length) {
        return this.item.answer_options
          .filter(a => !a.deleted)
          .reduce((acc, curr) => acc || curr.title.length == 0, false);
      }

      return true;
    },
    isValid() {
      return this.item.title.length && this.item.answer_options.length;
    }
  },
  methods: {
    cancelEdit() {
      this.$emit("update");
      this.editing = false;
    },
    isDraft(alt) {
      return alt.id && `${alt.id}`.indexOf("local-alt") > -1;
    },
    onRemoveQuestion() {
      if (this.item.id) {
        this.dialog_remove = true;
      } else {
        this.$emit("remove", this.index);
      }
    },
    submitDeleteQuestion() {
      this.$emit("delete", this.index);
    },
    removeAlternative(alt_index) {
      if (this.isDraft(this.item.answer_options[alt_index])) {
        this.item.answer_options = [
          ...this.item.answer_options.filter((_, i) => i != alt_index)
        ];
      } else {
        const new_item = { ...this.item };
        new_item.answer_options[alt_index].deleted = true;
        this.item = new_item;
      }
    },
    addAlternatives() {
      this.item.answer_options = [
        ...this.item.answer_options,
        {
          id: `local-alt-${new Date().getTime().toString()}`,
          title: "",
          is_right_answer: false
        }
      ];
    },
    reAddLocalIds() {
      // workaround to fix ids when user get a error
      this.item.answer_options = [
        ...this.item.answer_options.map(a => {
          const n_option = {
            ...a,
            id: a.id || a.id_temp
          };
          delete n_option.id_temp;
          return n_option;
        })
      ];
      this.right_answer = this.item.answer_options.find(
        o => o.is_right_answer
      ).id;
    },
    build_payload(form) {
      const data = { ...form };
      for (let k in data.questions) {
        const alternatives = [...data.questions[k].answer_options];
        for (let i in alternatives) {
          if (
            alternatives[i].id &&
            `${alternatives[i].id}`.indexOf("local-alt") > -1
          ) {
            alternatives[i].id_temp = alternatives[i].id; // workaround to fix ids when user get a error
            delete alternatives[i].id;
          }
        }

        data.questions[k].answer_options = alternatives;
      }

      let release_at = form.release_at || null;
      if (form.release_at && form.release_at.length == 10) {
        release_at = moment(form.release_at, "YYYY-MM-DD").toISOString();
      }

      if (this.isFinalQuiz && Object.keys(data).includes("module_id")) {
        delete data.module_id;
      }

      return { ...data, release_at };
    },
    submitSaveQuestion() {
      if (this.loading) return;

      if (!this.item.title.length) {
        this.$message.warning(`Digite o título da pergunta ${this.index + 1}.`);
        return;
      }

      if (!this.item.answer_options.length) {
        this.$message.warning(
          `Por favor, adicione as alternativas da pergunta ${this.index + 1}.`
        );
        return;
      }

      if (
        this.form.release_at &&
        !moment(this.form.release_at, "YYYY-MM-DD", true).isValid()
      ) {
        this.$message.warning(
          "Digite uma data válida, maior que hoje para liberação da avaliação em uma data específica"
        );
        return;
      }

      if (!this.question_without_right_answer) {
        this.$message.warning(
          `Por favor, indique a resposta correta da pergunta ${this.index + 1}.`
        );
        return;
      }

      if (this.question_without_title) {
        this.$message.warning(
          `Por favor, verifique as alternativas, ainda há pelo menos uma alternativa sem texto.`
        );
        return;
      }

      const payload = this.build_payload({
        ...this.form,
        number_of_attempts: Number(this.form.number_of_attempts) + 1,
        product_id: this.$route.params.id
      });

      let action = this.isFinalQuiz
        ? "membersQuizzes/postFinal"
        : "membersQuizzes/post";

      if (payload.id) {
        action = this.isFinalQuiz
          ? "membersQuizzes/putFinal"
          : "membersQuizzes/put";
      }

      this.loading = true;
      this.$store
        .dispatch(
          action,
          this.isFinalQuiz
            ? {
                final_quiz: payload,
                product_id: this.$route.params.id,
                release_final_quiz_when_finished: this.form
                  .release_final_quiz_when_finished
              }
            : payload
        )
        .then(() => {
          this.$message.success(`A pergunta ${this.index + 1} foi salva!`);
          this.editing = false;
          this.$emit("update");
        })
        .catch(e => {
          const data = this.isFinalQuiz
            ? e.response.data.final_quiz
            : e.response.data;

          let msg = get_error_msg(
            data,
            "TRANSLATE_FIELD_QUIZZ_MAP",
            `Não foi possível salvar a pergunta ${this.index + 1}!`,
            `Verifique a lista de questões - `
          );

          this.$message.error(msg);

          this.reAddLocalIds();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.form-quizz-question-item-component {
  border-radius: 16px;
  border: 1px solid var(--dark-10);
  background: var(--bg-1);
  padding: 24px;
  transition: 0.2s ease-in-out all;

  &:hover {
    border: 1px solid var(--dark-20);
  }

  .quizz-question-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .btn-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-height: 20px;
    .fa-grip-vertical {
      color: #9b9db0db;
    }

    h6 {
      color: var(--l-neutral-105, rgba(38, 36, 50, 0.93));
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
    }
  }

  .button-add-question {
    display: flex;
    align-items: center;
    border: none;
    background: none;
    padding: 0px;
    width: 100%;
    i {
      font-size: 19.5px;
      color: var(--blue-secondary);
    }

    span {
      background: var(--dark-4);
      border-radius: 16px;
      padding: 20px 16px;
      width: 100%;
      text-align: start;
      color: var(--dark-20);
      font-size: 14px;
    }
  }

  .lead {
    cursor: grab;
  }

  .quizz-question-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 20px;
  }

  ::v-deep .form-control:disabled {
    background-color: transparent !important;
    border-color: transparent !important;
  }

  ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
    color: var(--bg-1);
    border-color: var(--blue);
    background-color: var(--blue);
  }
}
</style>
